import { Box } from 'components/Box/Box';
import { Icon } from 'components/Icon/Icon';
import { LoadingDots } from 'components/LoadingDots/LoadingDots';
import { BodySmall } from 'components/Text/BodySmall';
import { colors } from 'theme/theme';

import { DropBox } from './FilePicker.styled';
import { Filename } from './Filename';
import type { FilePickerProps } from './types';

type Props = Pick<
  FilePickerProps,
  | 'fileId'
  | 'showDate'
  | 'hideRemove'
  | 'downloadAttachment'
  | 'disabled'
  | 'onChange'
  | 'message'
> & {
  qaId: string;
  onClick: () => void;
  filename?: string | null;
  created?: string | number | Date;
  loading?: boolean;
  onChange: (fileId?: string) => void;
  helpText: string;
};
export function ContentSmall({
  onClick,
  fileId,
  filename,
  qaId,
  hideRemove,
  onChange,
  loading,
  showDate,
  downloadAttachment,
  disabled,
  created,
  message,
  helpText,
  ...props
}: Props) {
  if (loading)
    return (
      <Box
        width={32}
        height={65}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <LoadingDots size="small" />
      </Box>
    );

  return (
    <>
      <Box data-qa-id={`${qaId}-selector`} mx={-10}>
        <DropBox
          position="relative"
          p={10}
          onClick={onClick}
          $hasFile={Boolean(fileId)}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        >
          <Box display="flex" alignItems="center" p="6px 16px">
            <Box ml="4px" mr="8px" display="inline-flex">
              <Icon name="paperclip" size={24} />
            </Box>
            <BodySmall my={0}>{message}</BodySmall>
          </Box>
        </DropBox>
      </Box>
      <Box display="inline-block" ml={24} color={colors.lightContentGrey}>
        {fileId ? (
          <Filename
            fileId={fileId}
            filename={filename}
            qaId={qaId}
            hideRemove={hideRemove}
            onChange={onChange}
            created={showDate ? created : undefined}
            downloadAttachment={downloadAttachment}
            disabled={disabled}
          />
        ) : (
          helpText
        )}
      </Box>
    </>
  );
}
